export default __webpack_public_path__ + "0f40cbdf23da7a1e5640ab76eab958ce.png";